import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TitleNode from './TitleNode';
import FlowCard from "../../../../../CommonComponents/FlowCard/FlowCard";
import history from "../../../../../history/history";
import { DataVal, ViewPillButton, ContributionsUnderlineLink, EmptyMessage, LoadButtonWrapper } from '../styles';
import { initiateTracking, formatShares, recordError } from '../../../../../utils/commonUtil';
import { getPrimaryAccount } from "../../../../../utils/sessionUtil";
import Popup from '../../MakeAContribution/Components/ContributionType/Components/Popup/Popup';
import { cancelContribution, replaceWithWholeData } from '../../ContributionActivity/actions';
import { contributionActivityCardState } from "../selectors";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
import Preloader from '../../../../../CommonComponents/Preloader/Preloader';
let currentTransactionId =-1;

export class ContributionActivityCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false
    }
  }

  renderTitleGrid(pool) {
    return <div>{pool.name}</div>;
  }

  renderFixGrid({ each, gridName, name }) {
    if(each[gridName] === "--"){
     return (<>
        <TitleNode title={name} />
        <div>&mdash;</div>
      </>)
    } else if(gridName === "noOfShares"){
    return (
      <>
        <TitleNode title={name} />
        <DataVal>
        {each['allShares'] ? 'All Shares' : formatShares(each[gridName])}
        </DataVal>
      </>
    )
    }else if(gridName === 'amount'){
      return (
        <>
        <TitleNode title={name} />
        <DataVal>
        {each['status'] === 'Reversed' ? '('+ each[gridName] + ')' : each[gridName]}
        </DataVal>
      </>
      )
    }
    return (
      <>
        <TitleNode title={name} />
        <DataVal>
         {each[gridName]}
        </DataVal>
      </>
    );
  }

  styleConfig() {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardDivider: true,
      cardPadding: true,
    };
  }

  renderViewButton(each, row){
    return (<ViewPillButton onClick={() => this.ViewContribution(each, row.status)}>View</ViewPillButton>)
  }

  ViewContribution(each) {
    try {
      history.push({pathname: '/contributions/activity/view', state: {transactionId: each.txnId, status: each.status, giftId: each.giftId}});
    } catch (error) {
      recordError(error);
    }
  }

   destObj(each, index) {
    return [
      {
        name: 'enteredDate',
        gridWidth: '50',
        type: 'FixGrid',
        render: this.renderFixGrid({ each, gridName: 'enteredDate', name: 'enteredDate*' }),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'description',
        type: 'FixGrid',
        gridWidth: '100',
        render: this.renderFixGrid({ each, gridName: 'description', name:'description' }),
        ptop: true,
        pbottom: true,
      },
      {
        name: 'amount',
        type: 'FixGrid',
        gridWidth: '50',
        render: this.renderFixGrid({ each, gridName: 'amount', name:'amount' }),
        ptop: true,
        pbottom: true,
      },
      {
        name: 'numberOfShares',
        type: 'FixGrid',
        gridWidth: '50',
        render: this.renderFixGrid({ each, gridName: 'noOfShares', name:'number of shares' }),
        ptop: true,
        pbottom: true,
        pleft: true,
      },
      {
        name: 'receivedDate',
        type: 'FixGrid',
        gridWidth: '50',
        render: this.renderFixGrid({ each, gridName: 'receivedDate', name: 'receivedDate**' }),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'status',
        type: 'FixGrid',
        gridWidth: '50',
        render: this.renderFixGrid({ each, gridName: 'status', name: 'status' }),
        ptop: true,
        pbottom: true,
        pleft: true,
      },
      {
        name: 'settledDate',
        type: 'FixGrid',
        gridWidth: '100',
        render: this.renderFixGrid({ each, gridName: 'settledDate', name: 'settledDate' }),
        ptop: true,
        pbottom: true,
      },
      {
        name: '',
        render: ( each.reversed ? '' : <ViewPillButton onClick={() => this.ViewContribution(each)}>View</ViewPillButton>),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: '',
        type: 'FixGrid',
        gridWidth: '50',
        render: ((each.status.toLowerCase() === "pending review" || each.status.toLowerCase() === "entered" || each.status.toLowerCase() === "assets needed" ) && each.reversed === false) ? (<ContributionsUnderlineLink data-test="contribute-later-btn" onClick={() => this.cancelClick(each) } >Cancel</ContributionsUnderlineLink>) : <></>,
        ptop: true,
        pbottom: true,
        pleft: true,
      },
    ];
  }

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleExitClick = () => {
    this.setState({
      show: !this.state.show
    });
    history.push("/my-account");
  };

  cancelContribution = () => {
    const data = {
      metaData: {
        method: "POST",
        page: "contributionActivity",
        url: {
          contributionActivity: `/donor-portal/api/contribution/${getPrimaryAccount().userId}/cancelContributionbyOrderId` 
        },
        data: {"orderId": currentTransactionId.orderId ? currentTransactionId.orderId : 0 ,"giftId": currentTransactionId.giftId}
      }
    };
    initiateTracking('cancelTable','Contribution Activity', currentTransactionId.status ,'Cancel');
    this.props.cancelContrib(data);
    this.setState({show:false});
  }

  cancelClick = (id) => {
    currentTransactionId = id;
      this.setState({show:true});
  }

render(){
  let contrData = [];
    if(this.props.contributionData !== undefined){
      contrData = this.props.contributionData;
     }else{
      contrData = [];
      return <Preloader/>
     }
     const resetPopupContent = this.props.drupalData ? 
     {
       heading: this.props.drupalData.field_header,
       line1: this.props.drupalData.field_description,
       line2: '',
       continue: this.props.drupalData.field_alert_button1_text,
       cancel: this.props.drupalData.field_alert_button2_text,
       type: 'exit'
     } : {
       heading: 'Cancel Contribution',
       line1:
         'Are you sure you want to cancel this contribution? Selecting continue will cancel the Contribution.',
       line2: 'Do you want to continue?',
       continue: 'Continue',
       cancel: 'No, take me back',
       type: 'exit'
     };
  return (
    <>
    {this.state.show === true ? (
            <Popup
              height="340px"
              width="500px"
              mwidth="88%"
              mheight="58%"
              data-test="popup"
              content={resetPopupContent}
              closeModal={this.closeModal}
              handleExitClick={()=> this.cancelContribution()}
            />
          ) : null}
      { contrData && contrData.length >0 ? contrData.map((each, index) => 
        (
        <FlowCard
          cardConfig={ this.destObj(each, index)}     
          index={index}
          data-test="flowCard"
          styleConfig={this.styleConfig()}
          scrollId="fromFlowCard"
        />
        )
      ) : <div class="ant-empty ant-empty-normal">
      
      <EmptyMessage class="ant-empty-description">{  this.props.loadMore || this.props.timeFrameData.dates!==null ?  "You currently have no contribution activity based on the filters applied.":"You currently have no contribution activity."}</EmptyMessage>
          </div>
    
    }
    {
      this.props.loadMore && <LoadButtonWrapper>
      <GeneralButton 
        onClick ={()=>{
          this.props.replaceWithWholeData(this.props.contributionWholeData)
        }} 
        text = "Load More" 
        styling="loadMore"
      />
      </LoadButtonWrapper>
    }
    </>
  );
}
}

ContributionActivityCard.propTypes = {
  contributionData: PropTypes.array,
  drupalData: PropTypes.array,
  cancelContrib: PropTypes.func
}

const mapStateToProps = state => ({
  ...contributionActivityCardState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  cancelContrib: data => dispatch(cancelContribution(data)),
  replaceWithWholeData: data => dispatch(replaceWithWholeData(data))
}); 

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContributionActivityCard);
